module.exports = __webpack_public_path__ + "img/modifications--tele-siderails.ee14918a.jpg";